<template>
  <div class="new-page-main">
    <!--搜索查询栏-->
    <dt-search-bar style="padding: 20px 5px 5px">
      <template slot="filterSlot">
        <data-filter ref="dataFilterRef" :timeData="$route.params.schoolId != 0 ? schoolTimeData : allTimeData"
          :schoolId="schoolId" :timesolt="1" :searchParams="searchParams" :contentObject="contentObject"
          :buttonColor="'#00CAAF'" @filter-data="filterData">
          <template slot="resourceSelect">
            <div v-if="tabsName == 'resource' && $route.params.schoolId != 0" style="width: 120px">
              <Select v-model="listFilters.resourceType" ref="resourceTypeRef" filterable placeholder="请选择资源类型"
                @on-change="selectResourceTypeChange">
                <Option value="0">全部资源</Option>
                <Option value="1">课件</Option>
                <Option value="2">微课</Option>
              </Select>
            </div>
          </template>
        </data-filter>
      </template>

      <template slot="addFilterSlot">
        <div v-if="tabsName == 'homework' && $route.params.schoolId != 0">
          <Select v-model="listFilters.hwType" ref="hwTypeRef" filterable placeholder="请选择作业类型"
            @on-change="selectHwTypeChange">
            <Option v-for="item in hwTypeList" :value="item.hwTypeCode" :key="item.hwTypeCode">{{ item.hwTypeName }}
            </Option>
          </Select>
        </div>
        <div v-if="tabsName == 'resource' && $route.params.schoolId != 0" style="width: 120px">
          <Select v-model="listFilters.isShareResource" ref="resourceRef" filterable placeholder="请选择资源状态"
            @on-change="selectResourceStateChange">
            <Option value="-1">全部状态</Option>
            <Option value="1">已分享资源</Option>
            <Option value="0">未分享资源</Option>
          </Select>
        </div>
      </template>
      <template slot="buttonSlot">
        <div style="display: flex; float: right">
          <!--搜索框-->
          <div class="big-data-search-input">
            <input :placeholder="placeholder" class="big-data-input-cla" v-model="listFilters.keyWord"
              v-on:keyup.enter="handleSearch" />
            <div class="big-data-search-btn" v-on:click="handleSearch">
              <div class="big-data-search-icon">
                <img src="../../../../assets/images/databoard/detailPage/search.png" width="100%" height="100%" />
              </div>
            </div>
          </div>
          <!--导出按钮-->
          <div v-on:click="exportInfoToExcel" class="export-btn" v-if="$route.params.schoolId != 0">
            列表导出
          </div>
          <div v-on:click="exportExcel" style="margin-left: 15px" class="export-btn" v-if="$route.params.schoolId != 0">
            汇总导出
          </div>
        </div>
      </template>
    </dt-search-bar>
    <!--数据展示切换-->
    <div class="new-data-tab-area" ref="tabChangeRef">
      <Tabs type="card" @on-click="changeDataDetailsIndex" :value="tabsName">
        <TabPane :label="$route.params.schoolId == 0 ? '作业详情' : '在线作业数'" name="homework"></TabPane>
        <TabPane v-if="$route.params.filtersName != 0" label="我的备课数" name="bookResource"></TabPane>
        <TabPane :label="$route.params.schoolId == 0 ? '资源详情' : '上传资源数'" name="resource"></TabPane>
        <TabPane v-if="$route.params.schoolId != 0" label="分享课件数" name="microClassKj"></TabPane>
        <TabPane :label="$route.params.schoolId == 0 ? '微课详情' : '分享微课数'" name="microClass"></TabPane>
        <TabPane label="探究学习墙数" name="inquiryLearning"></TabPane>
      </Tabs>
      <div v-on:click="openBigDataPath" class="hwNum-btn export-btn"
        v-if="$route.params.schoolId != 0 && tabsName === 'homework' && (adminType === 2 || userType === 5)">
        线下作业数
      </div>
    </div>
    <div class="tab-content">
      <tea-book-resource v-if="tabsName === 'bookResource'" :teaId="teaId"
        :teaName="$route.params.filtersName"></tea-book-resource>
      <template v-else>
        <!--数据统计图-->
        <div class="data-statistics-img" ref="dataStatistics">
          <ul>
            <template v-for="(item, index) in dataSummaryMap">
              <data-statis-summary :num="item.value" :text="item.key"
                :remindText="item.remindText"></data-statis-summary>
            </template>
          </ul>
        </div>
        <!--页面表格-->
        <div class="new-table-main-wrap" ref="tableMainRef">
          <div class="table-main">
            <!--作业列表-->
            <Table :columns="$route.params.schoolId != 0 ? schoolHwColumn : totalHwColumn
              " :data="$route.params.schoolId != 0 ? homeworkList : totalDataList" :row-class-name="rowClassName"
              :loading="isLoading" v-if="tabsName == 'homework'" :scroll="{ x: 1500 }"></Table>
            <!--资源列表-->
            <Table :columns="$route.params.schoolId != 0
                ? schoolResourceColumn
                : totalResourceColumn
              " :data="$route.params.schoolId != 0 ? resourceList : totalDataList" :row-class-name="rowClassName"
              :loading="isLoading" v-if="tabsName == 'resource'"></Table>
            <!--分享课件列表-->
            <Table :columns="schoolMicroKjColumn" :data="microKjList" :row-class-name="rowClassName"
              :loading="isLoading" v-if="tabsName == 'microClassKj'" :scroll="{ x: 1500 }"></Table>
            <!--微课列表-->
            <Table :columns="$route.params.schoolId != 0
                ? schoolMicroColumn
                : totalMicroColumn
              " :data="$route.params.schoolId != 0 ? microList : totalDataList" :row-class-name="rowClassName"
              :loading="isLoading" v-if="tabsName == 'microClass'"></Table>
            <!--探究学习墙-->
            <Table :columns="$route.params.schoolId != 0
                ? schoolLearnColumn
                : totalLearnColumn
              " :data="$route.params.schoolId != 0 ? learnList : totalDataList" :row-class-name="rowClassName"
              :loading="isLoading" v-if="tabsName == 'inquiryLearning'"></Table>
          </div>
          <div class="bottom-page">
            <div class="laypage_main">
              <Page :total="pageParams.total" @on-change="handleCurrentChange" :current="pageParams.page"
                v-if="pageParams.total && pageParams.pageCount > 1" show-total></Page>
            </div>
          </div>
        </div>
      </template>
    </div>
    <!-- 预览轮播 -->
    <dt-preview-slider ref="previewSlider" :previewMode="previewMode" :previewVideoMode="previewVideoMode"
      :videoSrc="videoSrc" @closePreview="closePreview"></dt-preview-slider>
  </div>
</template>

<script>
import {
  findResourceNewList,
  findResourceDataSummary,
  findUploadResourceSummary,
  findMicroList,
  findMicroDataSummary,
  findHwDetail,
  findHomeworkSummary,
  findTotalBySchool,
  findTotalDataBySchool,
  findHwTypeCodeList,
  findInquiryList,
  findInquirySummary,
  findShareCoursewareList,
} from "../../../../service/bigDataApi.js";
import { findUserInfo, findResourceInfo } from "../../../../service/api.js";
import { mapGetters } from "vuex";

const DtSearchBar = () => import("../../../../components/DtSearchBar");
const DataFilter = () => import("../../../../components/DataFilter");
const DataStatisSummary = () =>
  import("../../../../components/DataStatisSummary");
const teaBookResource = () => import("./teaBookResource.vue");
export default {
  name: "new-data-list",
  components: {
    // previewSlider,
    DtSearchBar,
    DataFilter,
    DataStatisSummary,
    teaBookResource,
  },
  computed: {
    ...mapGetters(["homeWorkReportPath",'adminType','userType']),
  },
  data() {
    return {
      //加载中
      isLoading: true,
      //各校时间切换按钮
      schoolTimeData: [
        {
          key: 0,
          value: "全部",
        },
        {
          key: 1,
          value: "近一周",
        },
        {
          key: 2,
          value: "近一月",
        },
        {
          key: 3,
          value: "自定义",
        },
      ],
      //总时间切换按钮
      allTimeData: [
        {
          key: 0,
          value: "全部",
        },
        {
          key: 1,
          value: "近一周",
        },
        {
          key: 2,
          value: "近一月",
        },
        {
          key: 4,
          value: "近三月",
        },
      ],
      //作业类型
      hwTypeList: [],
      searchParams: {
        classId:
          this.$route.params.classId == undefined
            ? "0"
            : this.$route.params.classId,
        gradeId:
          this.$route.params.gradeId == undefined
            ? "0"
            : this.$route.params.gradeId,
        subjectId:
          this.$route.params.subjectId == undefined
            ? "0"
            : this.$route.params.subjectId,
      },
      //数据概览集合
      dataSummaryMap: [],
      teaId: this.$route.params.teaId,
      tabsName: this.$route.params.tabsName,
      contentObject: {
        //是否显示学年切换按钮
        displayYearFilter: true,
        //是否显示时间切换按钮
        displayTimeFilter: true,
        //是否显示学科下拉框
        displaySubjectFilter: this.$route.params.schoolId == 0 ? false : true,
        //是否显示年级下拉框
        displayGradeFilter: this.$route.params.schoolId == 0 ? false : true,
        //是否显示班级下拉框
        displayClassFilter:
          this.$route.params.schoolId == 0
            ? false
            : this.$route.params.tabsName != "resource",
        //是否显示省份下拉框
        displayProvinceFilter: this.$route.params.schoolId == 0 ? true : false,
        //是否显示城市下拉框
        displayCityFilter: this.$route.params.schoolId == 0 ? true : false,
        //是否显示地区下拉框
        displayDistrictFilter: this.$route.params.schoolId == 0 ? true : false,
      },
      schoolId:
        this.$route.params.schoolId == 0 ? "" : this.$route.params.schoolId,
      //列表参数
      listFilters: {
        keyWord:
          this.$route.params.filtersName == "0"
            ? ""
            : this.$route.params.filtersName,
        hwType: "-1",
        isShareMicro: "0",
        isShareResource: "-1",
        resourceType: "0",
      },
      filters: {},
      resourceList: [], //资源详情集合
      homeworkList: [], //作业详情集合
      microList: [], //微课详情集合
      microKjList: [], //分享课件详情集合
      learnList: [], //探究学习墙详情集合
      pageParams: {
        page: 1,
        limit: 10,
        total: 0,
        pageCount: 0,
      },
      previewMode: false,
      previewVideoMode: false,
      videoSrc: "",

      dataDetailStyle: {
        height: "850px",
      },
      searchHeight: "",
      placeholder: "",
      //各校资源列
      schoolResourceColumn: [
        {
          title: "资源名称",
          key: "title",
          width: 300,
          render: (h, params) => {
            return h("div", [
              h(
                "a",
                {
                  attrs: {
                    title: "点击查看资源",
                    href: "javascript:void(0);",
                  },
                  style: {
                    color: "#0199ff",
                    fontSize: "14px",
                  },
                  on: {
                    click: () => {
                      this.openPreview(
                        params.row.user_id,
                        params.row.result_url,
                        params.row.img_count,
                        params.row.file_type,
                        params.index,
                        "resource"
                      );
                    },
                  },
                },
                params.row.title
              ),
            ]);
          },
        },
        {
          title: "资源类型",
          key: "resourceType",
          render: (h, params) => {
            return h("div", params.row.resourceType == 1 ? "课件" : "微课");
          },
        },

        {
          title: "上传教师",
          key: "user_name",
        },
        {
          title: "授课年级",
          key: "grade_name",
        },
        {
          title: "授课学科",
          key: "subject_name",
        },
        {
          title: "上传时间",
          key: "biz_date",
          width: 200,
          renderHeader: (h, params) => {
            return h(
              "div",
              {
                attrs: {
                  class: "sort-col",
                },
                on: {
                  click: () => {
                    this.sortData("biz_date");
                  },
                },
              },
              [
                h(
                  "span",
                  {
                    style: {
                      cursor: "pointer",
                    },
                  },
                  "上传时间"
                ),
                h("img", {
                  attrs: {
                    class: "sort-fun",
                    src: "/icon_change.png",
                  },
                  style: {
                    cursor: "pointer",
                  },
                }),
              ]
            );
          },
        },
        {
          title: "状态",
          key: "is_share",
          render: (h, params) => {
            return h("div", params.row.is_share == "0" ? "未分享" : "已分享");
          },
        },
      ],
      //全部资源列
      totalResourceColumn: [
        {
          title: "省级行政区",
          key: "province_name",
        },
        {
          title: "市级行政区",
          key: "city_name",
        },
        {
          title: "所属区域",
          key: "district_name",
        },
        {
          title: "学校名称",
          key: "school_name",
          render: (h, params) => {
            return h("div", [
              h(
                "a",
                {
                  attrs: {
                    title: "点击查看各校数据展板",
                    href: "javascript:void(0);",
                  },
                  style: {
                    color: "#0199ff",
                    fontSize: "14px",
                  },
                  on: {
                    click: () => {
                      this.lookSchoolDataBoard(params.row);
                    },
                  },
                },
                params.row.school_name
              ),
            ]);
          },
        },
        {
          title: "资源上传数",
          key: "rs_upload_num",
          renderHeader: (h, params) => {
            return h(
              "div",
              {
                attrs: {
                  class: "sort-col",
                },
                on: {
                  click: () => {
                    this.sortData("rs_upload_num");
                  },
                },
              },
              [
                h(
                  "span",
                  {
                    style: {
                      cursor: "pointer",
                    },
                  },
                  "资源上传数"
                ),
                h("img", {
                  attrs: {
                    class: "sort-fun",
                    src: "/icon_change.png",
                  },
                  style: {
                    cursor: "pointer",
                  },
                }),
              ]
            );
          },
        },
        {
          title: "资源分享数",
          key: "rs_share_num",
          renderHeader: (h, params) => {
            return h(
              "div",
              {
                attrs: {
                  class: "sort-col",
                },
                on: {
                  click: () => {
                    this.sortData("rs_share_num");
                  },
                },
              },
              [
                h(
                  "span",
                  {
                    style: {
                      cursor: "pointer",
                    },
                  },
                  "资源分享数"
                ),
                h("img", {
                  attrs: {
                    class: "sort-fun",
                    src: "/icon_change.png",
                  },
                  style: {
                    cursor: "pointer",
                  },
                }),
              ]
            );
          },
        },
        {
          title: "资源查看数",
          key: "rs_read_num",
          renderHeader: (h, params) => {
            return h(
              "div",
              {
                attrs: {
                  class: "sort-col",
                },
                on: {
                  click: () => {
                    this.sortData("rs_read_num");
                  },
                },
              },
              [
                h(
                  "span",
                  {
                    style: {
                      cursor: "pointer",
                    },
                  },
                  "资源查看数"
                ),
                h("img", {
                  attrs: {
                    class: "sort-fun",
                    src: "/icon_change.png",
                  },
                  style: {
                    cursor: "pointer",
                  },
                }),
              ]
            );
          },
        },
      ],
      //各校作业列
      schoolHwColumn: [
        {
          title: "作业名称",
          key: "hw_title",
          width: 200,
          fixed: 'left',
          render: (h, params) => {
            return h("div", [
              h(
                "a",
                {
                  attrs: {
                    title: "点击查看作业",
                    href: "javascript:void(0);",
                  },
                  style: {
                    color: "#0199ff",
                    fontSize: "14px",
                  },
                  on: {
                    click: () => {
                      this.findUserSubjectByUserId(
                        params.row.tea_id,
                        params.row.hw_id,
                        params.row.hw_title,
                        params.row.hw_type,
                        params.row.hw_type_code
                      );
                    },
                  },
                },
                params.row.hw_title
              ),
            ]);
          },
        },
        {
          title: "所属年级",
          key: "grade_name",
          minWidth: 100,
        },
        {
          title: "所属学年",
          key: "school_year",
          minWidth: 100,
        },
        {
          title: "所属班级",
          key: "class_name",
          minWidth: 100,
        },
        {
          title: "所属学科",
          key: "subject_name",
          minWidth: 100,
        },
        {
          title: "作业类型",
          key: "hw_type_name",
          minWidth: 110,
        },
        // {
        //   title: "接收人数",
        //   key: "stu_num",
        //   minWidth: 100,
        // },
        {
          title: "接收人数",
          key: "hw_num",
          minWidth: 90,
          renderHeader: (h, params) => {
            return h(
              "div",
              {
                attrs: {
                  class: "sort-col",
                },
                style: { whiteSpace: "nowrap" },
                on: {
                  click: () => {
                    this.sortData("hw_num");
                  },
                },
              },
              [
                h(
                  "span",
                  {
                    style: {
                      cursor: "pointer",
                      whiteSpace: "nowrap",
                    },
                  },
                  "接收人数"
                ),
                h("img", {
                  attrs: {
                    class: "sort-fun",
                    src: "/icon_change.png",
                  },
                  style: {
                    cursor: "pointer",
                  },
                }),
              ]
            );
          },
        },
        {
          title: "提交人数",
          key: "hw_submit_num",
          minWidth: 90,
          render: (h, params) => {
            // 显示0也能正常渲染
            return h('span', params.row.hw_submit_num === 0 ? '0' : (params.row.hw_submit_num || ''));
          }
        },
        {
          title: "批改人数",
          key: "hw_correct_num",
          minWidth: 90,
          render: (h, params) => {
            // 显示0也能正常渲染
            return h('span', params.row.hw_correct_num === 0 ? '0' : (params.row.hw_correct_num || ''));
          }
        },
        {
          title: "作业提交率",
          key: "hwSubmitRate",
          minWidth: 100,
          render: (h, params) => {
            return h('span', (params.row.hwSubmitRate === 0 || params.row.hwSubmitRate === '0' || params.row.hwSubmitRate === '0%') ? '0%' : (params.row.hwSubmitRate + '%' || ''));
          }
        },
        {
          title: "作业批改率",
          key: "hwCorrectRate",
          minWidth: 100,
          render: (h, params) => {
            return h('span', (params.row.hwCorrectRate === 0 || params.row.hwCorrectRate === '0' || params.row.hwCorrectRate === '0%') ? '0%' : (params.row.hwCorrectRate + '%' || ''));
          }
        },
        {
          title: "发送人",
          key: "tea_name",
          minWidth: 100,
        },
        {
          title: "发送时间",
          key: "biz_date",
          width: 160,
          renderHeader: (h, params) => {
            return h(
              "div",
              {
                attrs: {
                  class: "sort-col",
                },
                style: { whiteSpace: "nowrap" },
                on: {
                  click: () => {
                    this.sortData("biz_date");
                  },
                },
              },
              [
                h(
                  "span",
                  {
                    style: {
                      cursor: "pointer",
                      whiteSpace: "nowrap",
                    },
                  },
                  "发送时间"
                ),
                h("img", {
                  attrs: {
                    class: "sort-fun",
                    src: "/icon_change.png",
                  },
                  style: {
                    cursor: "pointer",
                  },
                }),
              ]
            );
          },
        },
      ],
      //全部作业列
      totalHwColumn: [
        {
          title: "省级行政区",
          key: "province_name",
        },
        {
          title: "市级行政区",
          key: "city_name",
        },
        {
          title: "所属区域",
          key: "district_name",
        },
        {
          title: "学校名称",
          key: "school_name",
          render: (h, params) => {
            return h("div", [
              h(
                "a",
                {
                  attrs: {
                    title: "点击查看各校数据展板",
                    href: "javascript:void(0);",
                  },
                  style: {
                    color: "#0199ff",
                    fontSize: "14px",
                  },
                  on: {
                    click: () => {
                      this.lookSchoolDataBoard(params.row);
                    },
                  },
                },
                params.row.school_name
              ),
            ]);
          },
        },
        {
          title: "作业布置总数",
          key: "tea_hw_num",
          renderHeader: (h, params) => {
            return h(
              "div",
              {
                attrs: {
                  class: "sort-col",
                },
                on: {
                  click: () => {
                    this.sortData("tea_hw_num");
                  },
                },
              },
              [
                h(
                  "span",
                  {
                    style: {
                      cursor: "pointer",
                    },
                  },
                  "作业布置总数"
                ),
                h("img", {
                  attrs: {
                    class: "sort-fun",
                    src: "/icon_change.png",
                  },
                  style: {
                    cursor: "pointer",
                  },
                }),
              ]
            );
          },
        },
        {
          title: "作业提交人数",
          key: "hw_submit_num",
          renderHeader: (h, params) => {
            return h(
              "div",
              {
                attrs: {
                  class: "sort-col",
                },
                on: {
                  click: () => {
                    this.sortData("hw_submit_num");
                  },
                },
              },
              [
                h(
                  "span",
                  {
                    style: {
                      cursor: "pointer",
                    },
                  },
                  "作业提交人数"
                ),
                h("img", {
                  attrs: {
                    class: "sort-fun",
                    src: "/icon_change.png",
                  },
                  style: {
                    cursor: "pointer",
                  },
                }),
              ]
            );
          },
        },
        {
          title: "作业批改总数",
          key: "hw_correct_num",
          renderHeader: (h, params) => {
            return h(
              "div",
              {
                attrs: {
                  class: "sort-col",
                },
                on: {
                  click: () => {
                    this.sortData("hw_correct_num");
                  },
                },
              },
              [
                h(
                  "span",
                  {
                    style: {
                      cursor: "pointer",
                    },
                  },
                  "作业批改总数"
                ),
                h("img", {
                  attrs: {
                    class: "sort-fun",
                    src: "/icon_change.png",
                  },
                  style: {
                    cursor: "pointer",
                  },
                }),
              ]
            );
          },
        },
      ],
      //各校微课列
      schoolMicroColumn: [
        {
          title: "微课名称",
          key: "wk_title",
          width: 200,
          fixed: 'left',
          render: (h, params) => {
            return h("div", [
              h(
                "a",
                {
                  attrs: {
                    title: "点击查看微课",
                    href: "javascript:void(0);",
                  },
                  style: {
                    color: "#0199ff",
                    fontSize: "14px",
                  },
                  on: {
                    click: () => {
                      this.openPreview(
                        params.row.userId,
                        params.row.file1,
                        0,
                        2,
                        params.index,
                        "micro",
                        params.row.wk_id
                      );
                    },
                  },
                },
                params.row.wk_title
              ),
            ]);
          },
        },
        {
          title: "学科",
          key: "subject_name",
          minWidth: 100
        },
        {
          title: "所属学年",
          key: "school_year",
          minWidth: 100
        },
        {
          title: "分享教师",
          key: "user_name",
          minWidth: 100
        },
        {
          title: "分享时间",
          key: "biz_date",
          width: 160,
          renderHeader: (h, params) => {
            return h(
              "div",
              {
                attrs: {
                  class: "sort-col",
                },
                on: {
                  click: () => {
                    this.sortData("biz_date");
                  },
                },
              },
              [
                h(
                  "span",
                  {
                    style: {
                      cursor: "pointer",
                    },
                  },
                  "分享时间"
                ),
                h("img", {
                  attrs: {
                    class: "sort-fun",
                    src: "/icon_change.png",
                  },
                  style: {
                    cursor: "pointer",
                  },
                }),
              ]
            );
          },
        },
        {
          title: "分享年级",
          key: "grade_name",
          minWidth: 100,
          render: (h, params) => {
            if (params.row.grade_name == "0") {
              return h("div", "/");
            } else {
              return h("div", params.row.grade_name);
            }
          },
        },

        {
          title: "分享班级",
          key: "class_name",
          minWidth: 100,
          render: (h, params) => {
            if (params.row.class_name == "0") {
              return h("div", "/");
            } else {
              return h("div", params.row.class_name);
            }
          },
        },
        {
          title: "接收人数",
          key: " receive_num",
          minWidth: 90,
          render: (h, params) => {
            // 显示0也能正常渲染
            return h('span', params.row.receive_num === 0 ? '0' : (params.row.receive_num || ''));
          }
        },
        {
          title: "查看人数",
          key: " read_num",
          minWidth: 90,
          render: (h, params) => {
            // 显示0也能正常渲染
            return h('span', params.row.read_num === 0 ? '0' : (params.row.read_num || ''));
          }
        },
        {
          title: "微课查看率",
          key: " read_rate",
          minWidth: 100,
          render: (h, params) => {
            // 0 或 0% 也能正常渲染
            return h('span', (params.row.read_rate === 0 || params.row.read_rate === '0' || params.row.read_rate === '0%') ? '0%' : (params.row.read_rate + '%' || ''));
          }
        },
        {
          title: "微课看懂率",
          key: " understand_rate",
          minWidth: 100,
          render: (h, params) => {
            return h('span', (params.row.understand_rate === 0 || params.row.understand_rate === '0' || params.row.understand_rate === '0%') ? '0%' : (params.row.understand_rate + '%' || ''));
          }
        }
      ],
      //各校课件列
      schoolMicroKjColumn: [
        {
          title: "课件名称",
          key: "rs_title",
          width: 200,
          fixed: 'left',
          render: (h, params) => {
            return h("div", [
              h(
                "a",
                {
                  attrs: {
                    title: "点击查看微课",
                    href: "javascript:void(0);",
                  },
                  style: {
                    color: "#0199ff",
                    fontSize: "14px",
                  },
                  on: {
                    click: () => {
                      this.openPreview(
                        params.row.user_id,
                        params.row.result_url,
                        params.row.img_count,
                        params.row.file_type,
                        params.index,
                        "micro"
                      );
                    },
                  },
                },
                params.row.rs_title
              ),
            ]);
          },
        },
        {
          title: "学科",
          key: "subject_name",
          minWidth: 100,
        },
        {
          title: "所属学年",
          key: "school_year",
          width: 140,
        },
        {
          title: "分享教师",
          key: "user_name",
          minWidth: 100,
        },
        {
          title: "分享时间",
          key: "biz_date",
          width: 160,
          renderHeader: (h, params) => {
            return h(
              "div",
              {
                attrs: {
                  class: "sort-col",
                },
                on: {
                  click: () => {
                    this.sortData("biz_date");
                  },
                },
              },
              [
                h(
                  "span",
                  {
                    style: {
                      cursor: "pointer",
                    },
                  },
                  "分享时间"
                ),
                h("img", {
                  attrs: {
                    class: "sort-fun",
                    src: "/icon_change.png",
                  },
                  style: {
                    cursor: "pointer",
                  },
                }),
              ]
            );
          },
        },
        {
          title: "分享年级",
          key: "grade_name",
          minWidth: 100,
          render: (h, params) => {
            if (params.row.grade_name == "0") {
              return h("div", "/");
            } else {
              return h("div", params.row.grade_name);
            }
          },
        },

        {
          title: "分享班级",
          key: "class_name",
          minWidth: 100,
          render: (h, params) => {
            if (params.row.class_name == "0") {
              return h("div", "/");
            } else {
              return h("div", params.row.class_name);
            }
          },
        },
        {
          title: "接收人数",
          key: "stu_num",
          minWidth: 90,
          render: (h, params) => {
            // 显示0也能正常渲染
            return h('span', params.row.stu_num === 0 ? '0' : (params.row.stu_num || ''));
          }
        },
        {
          title: "查看人数",
          key: "read_num",
          minWidth: 90,
          render: (h, params) => {
            // 显示0也能正常渲染
            return h('span', params.row.read_num === 0 ? '0' : (params.row.read_num || ''));
          }
        },
        {
          title: "课件查看率",
          key: "read_rate",
          minWidth: 100,
          render: (h, params) => {
            // 0 或 0% 也能正常渲染
            return h('span', (params.row.read_rate === 0 || params.row.read_rate === '0' || params.row.read_rate === '0%') ? '0%' : (params.row.read_rate + '%' || ''));
          }
        },
        {
          title: "课件看懂率",
          key: "understand_rate",
          minWidth: 100,
          render: (h, params) => {
            return h('span', (params.row.understand_rate === 0 || params.row.understand_rate === '0' || params.row.understand_rate === '0%') ? '0%' : (params.row.understand_rate + '%' || ''));
          }
        }
      ],
      //全部微课列
      totalMicroColumn: [
        {
          title: "省级行政区",
          key: "province_name",
        },
        {
          title: "市级行政区",
          key: "city_name",
        },
        {
          title: "所属区域",
          key: "district_name",
        },
        {
          title: "学校名称",
          key: "school_name",
          render: (h, params) => {
            return h("div", [
              h(
                "a",
                {
                  attrs: {
                    title: "点击查看各校数据展板",
                    href: "javascript:void(0);",
                  },
                  style: {
                    color: "#0199ff",
                    fontSize: "14px",
                  },
                  on: {
                    click: () => {
                      this.lookSchoolDataBoard(params.row);
                    },
                  },
                },
                params.row.school_name
              ),
            ]);
          },
        },
        {
          title: "微课上传数",
          key: "cw_upload_num",
          renderHeader: (h, params) => {
            return h(
              "div",
              {
                attrs: {
                  class: "sort-col",
                },
                on: {
                  click: () => {
                    this.sortData("cw_upload_num");
                  },
                },
              },
              [
                h(
                  "span",
                  {
                    style: {
                      cursor: "pointer",
                    },
                  },
                  "微课上传数"
                ),
                h("img", {
                  attrs: {
                    class: "sort-fun",
                    src: "/icon_change.png",
                  },
                  style: {
                    cursor: "pointer",
                  },
                }),
              ]
            );
          },
        },
        {
          title: "微课分享数",
          key: "cw_share_num",
          renderHeader: (h, params) => {
            return h(
              "div",
              {
                attrs: {
                  class: "sort-col",
                },
                on: {
                  click: () => {
                    this.sortData("cw_share_num");
                  },
                },
              },
              [
                h(
                  "span",
                  {
                    style: {
                      cursor: "pointer",
                    },
                  },
                  "微课分享数"
                ),
                h("img", {
                  attrs: {
                    class: "sort-fun",
                    src: "/icon_change.png",
                  },
                  style: {
                    cursor: "pointer",
                  },
                }),
              ]
            );
          },
        },
        {
          title: "微课查看数",
          key: "cw_read_num",
          renderHeader: (h, params) => {
            return h(
              "div",
              {
                attrs: {
                  class: "sort-col",
                },
                on: {
                  click: () => {
                    this.sortData("cw_read_num");
                  },
                },
              },
              [
                h(
                  "span",
                  {
                    style: {
                      cursor: "pointer",
                    },
                  },
                  "微课查看数"
                ),
                h("img", {
                  attrs: {
                    class: "sort-fun",
                    src: "/icon_change.png",
                  },
                  style: {
                    cursor: "pointer",
                  },
                }),
              ]
            );
          },
        },
      ],
      //各校探究学习墙列
      schoolLearnColumn: [
        {
          title: "学习墙名称",
          key: "inquiry_title",
          width: 300,
          render: (h, params) => {
            return h("div", [
              h(
                "a",
                {
                  attrs: {
                    title: "点击查看学习墙",
                    href: "javascript:void(0);",
                  },
                  style: {
                    color: "#0199ff",
                    fontSize: "14px",
                  },
                  on: {
                    click: () => {
                      this.openStudyBoard(params.row);
                    },
                  },
                },
                params.row.inquiry_title
              ),
            ]);
          },
        },
        {
          title: "年级",
          key: "grade_name",
        },
        {
          title: "所属学年",
          key: "school_year",
        },
        {
          title: "学科",
          key: "subject_name",
        },
        {
          title: "发送人",
          key: "tea_name",
        },
        {
          title: "发送班级",
          key: "class_name",
        },
        {
          title: "发送时间",
          key: "biz_date",
          width: 160,
          renderHeader: (h, params) => {
            return h(
              "div",
              {
                attrs: {
                  class: "sort-col",
                },
                on: {
                  click: () => {
                    this.sortData("biz_date");
                  },
                },
              },
              [
                h(
                  "span",
                  {
                    style: {
                      cursor: "pointer",
                    },
                  },
                  "发送时间"
                ),
                h("img", {
                  attrs: {
                    class: "sort-fun",
                    src: "/icon_change.png",
                  },
                  style: {
                    cursor: "pointer",
                  },
                }),
              ]
            );
          },
        },
        {
          title: "接收人数",
          key: "receive_num",
          renderHeader: (h, params) => {
            return h(
              "div",
              {
                attrs: {
                  class: "sort-col",
                },
                on: {
                  click: () => {
                    this.sortData("receive_num");
                  },
                },
              },
              [
                h(
                  "span",
                  {
                    style: {
                      cursor: "pointer",
                    },
                  },
                  "接收人数"
                ),
                h("img", {
                  attrs: {
                    class: "sort-fun",
                    src: "/icon_change.png",
                  },
                  style: {
                    cursor: "pointer",
                  },
                }),
              ]
            );
          },
        },
        {
          title: "参与人数",
          key: "partake_num",
          renderHeader: (h, params) => {
            return h(
              "div",
              {
                attrs: {
                  class: "sort-col",
                },
                on: {
                  click: () => {
                    this.sortData("partake_num");
                  },
                },
              },
              [
                h(
                  "span",
                  {
                    style: {
                      cursor: "pointer",
                    },
                  },
                  "参与人数"
                ),
                h("img", {
                  attrs: {
                    class: "sort-fun",
                    src: "/icon_change.png",
                  },
                  style: {
                    cursor: "pointer",
                  },
                }),
              ]
            );
          },
        },
      ],
      //全部探究学习列
      totalLearnColumn: [
        {
          title: "省级行政区",
          key: "province_name",
        },
        {
          title: "市级行政区",
          key: "city_name",
        },
        {
          title: "所属区域",
          key: "district_name",
        },
        {
          title: "学校名称",
          key: "school_name",
          render: (h, params) => {
            return h("div", [
              h(
                "a",
                {
                  attrs: {
                    title: "点击查看各校数据展板",
                    href: "javascript:void(0);",
                  },
                  style: {
                    color: "#0199ff",
                    fontSize: "14px",
                  },
                  on: {
                    click: () => {
                      this.lookSchoolDataBoard(params.row);
                    },
                  },
                },
                params.row.school_name
              ),
            ]);
          },
        },
        {
          title: "发送次数",
          key: "inquiry_send_num",
          renderHeader: (h, params) => {
            return h(
              "div",
              {
                attrs: {
                  class: "sort-col",
                },
                on: {
                  click: () => {
                    this.sortData("inquiry_send_num");
                  },
                },
              },
              [
                h(
                  "span",
                  {
                    style: {
                      cursor: "pointer",
                    },
                  },
                  "发送次数"
                ),
                h("img", {
                  attrs: {
                    class: "sort-fun",
                    src: "/icon_change.png",
                  },
                  style: {
                    cursor: "pointer",
                  },
                }),
              ]
            );
          },
        },
        {
          title: "动态数量",
          key: "inquiry_dynamic_num",
          renderHeader: (h, params) => {
            return h(
              "div",
              {
                attrs: {
                  class: "sort-col",
                },
                on: {
                  click: () => {
                    this.sortData("inquiry_dynamic_num");
                  },
                },
              },
              [
                h(
                  "span",
                  {
                    style: {
                      cursor: "pointer",
                    },
                  },
                  "动态数量"
                ),
                h("img", {
                  attrs: {
                    class: "sort-fun",
                    src: "/icon_change.png",
                  },
                  style: {
                    cursor: "pointer",
                  },
                }),
              ]
            );
          },
        },
        {
          title: "参与人数",
          key: "inquiry_partake_num",
          renderHeader: (h, params) => {
            return h(
              "div",
              {
                attrs: {
                  class: "sort-col",
                },
                on: {
                  click: () => {
                    this.sortData("inquiry_partake_num");
                  },
                },
              },
              [
                h(
                  "span",
                  {
                    style: {
                      cursor: "pointer",
                    },
                  },
                  "参与人数"
                ),
                h("img", {
                  attrs: {
                    class: "sort-fun",
                    src: "/icon_change.png",
                  },
                  style: {
                    cursor: "pointer",
                  },
                }),
              ]
            );
          },
        },
      ],
      //各校作业列表排序参数
      schoolHwDataSortArr: [
        {
          sortType: "hw_num",
          orderType: "desc",
        },
        {
          sortType: "biz_date",
          orderType: "desc",
        },
      ],
      //全部作业列表排序参数
      tolHwDataSortArr: [
        {
          sortType: "tea_hw_num",
          orderType: "desc",
        },
        {
          sortType: "hw_submit_num",
          orderType: "desc",
        },
        {
          sortType: "hw_correct_num",
          orderType: "desc",
        },
      ],
      //各校资源列表排序参数
      schoolResDataSortArr: [
        {
          sortType: "share_num",
          orderType: "desc",
        },
        {
          sortType: "biz_date",
          orderType: "desc",
        },
      ],
      //全部资源列表排序参数
      tolResDataSortArr: [
        {
          sortType: "rs_upload_num",
          orderType: "desc",
        },
        {
          sortType: "rs_share_num",
          orderType: "desc",
        },
        {
          sortType: "rs_read_num",
          orderType: "desc",
        },
      ],
      //各校微课列表排序参数
      schoolMicroDataSortArr: [
        {
          sortType: "biz_date",
          orderType: "desc",
        },
      ],
      //全部微课列表排序参数
      tolMicroDataSortArr: [
        {
          sortType: "cw_upload_num",
          orderType: "desc",
        },
        {
          sortType: "cw_share_num",
          orderType: "desc",
        },
        {
          sortType: "cw_read_num",
          orderType: "desc",
        },
      ],
      //各校探究学习列表排序参数
      schoolLearnDataSortArr: [
        {
          sortType: "biz_date",
          orderType: "desc",
        },
        {
          sortType: "receive_num",
          orderType: "desc",
        },
        {
          sortType: "partake_num",
          orderType: "desc",
        },
      ],
      //全部探究学习列表排序参数
      tolLearnDataSortArr: [
        {
          sortType: "inquiry_send_num",
          orderType: "desc",
        },
        {
          sortType: "inquiry_dynamic_num",
          orderType: "desc",
        },
        {
          sortType: "inquiry_partake_num",
          orderType: "desc",
        },
      ],
      tolHwDataOrder: "tea_hw_num desc",
      schoolHwDataOrder: "biz_date desc",
      tolResDataOrder: "rs_share_num desc",
      schoolResDataOrder: "biz_date desc",
      schoolMicroKjDataOrder: "biz_date desc",
      tolMicroDataOrder: "cw_share_num desc",
      schoolMicroDataOrder: "biz_date desc",
      tolLearnDataOrder: "inquiry_send_num desc",
      schoolLearnDataOrder: "biz_date desc",
    };
  },
  created() {
    this.setCurrentPathArr();
  },
  watch: {
    "listFilters.keyWord": {
      handler(newValue, oldValue) {
        this.handleSearch();
      },
      deep: true,
    },
  },
  methods: {
    /**
     * 设置面包屑
     */
    setCurrentPathArr() {
      let currentPathArr;
      currentPathArr = [
        {
          title: "首页",
          path:
            this.$route.params.schoolId == "75047a8a0990480f8abf3a39bc25f1ab"
              ? "cloudschooldataboard"
              : "schooldataboard",
          name:
            this.$route.params.schoolId == "75047a8a0990480f8abf3a39bc25f1ab"
              ? "cloudschooldataboard"
              : "schooldataboard",
          params: {
            schoolId: this.$route.params.schoolId,
          },
          query: {
            tokenId: this.$store.getters.token,
          },
        },
        {
          title: this.$route.params.schoolName,
          path: "",
          name: "schoolName",
        },
        {
          title:
            this.tabsName == "homework"
              ? "全部作业"
              : this.tabsName == "resource"
                ? "全部资源"
                : this.tabsName == "microClassKj"
                  ? "全部课件"
                  : this.tabsName == "microClass"
                    ? "全部微课"
                    : this.tabsName == "bookResource"
                      ? "我的备课数"
                      : "探究学习墙",
          path: "",
          name:
            this.tabsName == "homework"
              ? "homeworkList"
              : this.tabsName == "resource"
                ? "resourceList"
                : "microList",
        },
      ];
      this.$store.commit("setCurrentPath", currentPathArr);
    },
    /**
     * 导出产品信息
     */
    exportInfoToExcel() {
      let _this = this;
      //接口
      let link = "";
      let params = "";
      let value = "";
      switch (this.tabsName) {
        case "homework":
          link = "/stats/homeworks/grades/dashboard/detail/export";
          params = "&hwTypeCode=";
          value = this.listFilters.hwType;
          break;
        case "resource":
          link = "/stats/resource/exportUploadResourceData";
          params = "&isshare=";
          value =
            "&isShare=" +
            (this.listFilters.isShareResource == "-1"
              ? ""
              : this.listFilters.isShareResource);
          break;
        case "microClassKj":
          link = "/stats/resource/operation/list/export";
          params = "&isshare=";
          value =
            "&isshare=" +
            (this.listFilters.isShareResource == "-1"
              ? ""
              : this.listFilters.isShareResource);
          break;
        case "microClass":
          link = "/stats/microclass/operation/list/export";
          params = "&isshare=";
          value =
            "&isshare=" + this.listFilters.isShareMicro == "0"
              ? ""
              : this.listFilters.isShareMicro;
          break;
        case "inquiryLearning":
          link = "/stats/inquirystudy/operation/list/export";
          params = "";
          value = "";
          break;
      }
      let url = "";
      let subjectId = this.filters.subjectId == 0 ? "" : this.filters.subjectId;
      let gradeId = this.filters.gradeId == 0 ? (this.filters.phaseGradeIds || "") : this.filters.gradeId;
      let classId = this.filters.classId == 0 ? "" : this.filters.classId;
      if (this.tabsName == "resource") {
        url =
          process.env.VUE_APP_APIURL +
          link +
          "?schoolId=" +
          this.schoolId +
          "&resourceType=" +
          (this.listFilters.resourceType == "0"
            ? ""
            : this.listFilters.resourceType) +
          "&startDate=" +
          this.filters.startDate +
          "&endDate=" +
          this.filters.endDate +
          "&subjectId=" +
          subjectId +
          "&gradeId=" +
          gradeId +
          "&keyWord=" +
          this.listFilters.keyWord +
          "&pageno=" +
          this.pageParams.page +
          "&pagesize=" +
          this.pageParams.limit +
          params +
          value;
      } else {
        url =
          process.env.VUE_APP_APIURL +
          link +
          "?schoolid=" +
          this.schoolId +
          "&startdate=" +
          this.filters.startDate +
          "&enddate=" +
          this.filters.endDate +
          "&subjectid=" +
          subjectId +
          "&gradeid=" +
          gradeId +
          "&classid=" +
          classId +
          "&keyword=" +
          this.listFilters.keyWord +
          "&pageno=" +
          this.pageParams.page +
          "&pagesize=" +
          this.pageParams.limit +
          params +
          value;
      }
      let iframe = document.createElement("iframe");
      iframe.style.display = "none";
      iframe.src = url;
      iframe.onload = function () {
        let msg = JSON.parse(iframe.contentDocument.body.innerText).msg;
        _this.$Message.error(msg);
        document.body.removeChild(iframe);
      };
      document.body.appendChild(iframe);
    },
    /**
     * @name 汇总导出
     */
    exportExcel() {
      let url =
        process.env.VUE_APP_APIURL +
        "/stats/resource/exportHwResData" +
        `?schoolId=${this.schoolId}&resourceType=${this.listFilters.resourceType == "0"
          ? ""
          : this.listFilters.resourceType
        }&startDate=${this.filters.startDate}&endDate=${this.filters.endDate
        }&keyWord=${this.listFilters.keyWord}&isShare=${this.listFilters.isShareResource == "-1"
          ? ""
          : this.listFilters.isShareResource
        }&subjectId=${this.filters.subjectId == 0 ? "" : this.filters.subjectId
        }&gradeId=${this.filters.gradeId == 0 ? (this.filters.phaseGradeIds || "") : this.filters.gradeId
        }&classId=${this.filters.classId == 0 ? "" : this.filters.classId}`;
      let iframe = document.createElement("iframe");
      iframe.style.display = "none";
      iframe.src = url;
      iframe.onload = function () {
        let msg = JSON.parse(iframe.contentDocument.body.innerText).msg;
        _this.$Message.error(msg);
        document.body.removeChild(iframe);
      };
      document.body.appendChild(iframe);
    },
    /**
     * 选择作业类型
     */
    selectHwTypeChange(val) {
      this.pageParams.page = 1;
      this.pageParams.total = 0;
      this.isLoading = true;
      this.filters.hwType = val == undefined ? "-1" : val;
      this.queryDataByTab("homework");
    },
    /**
     * 选择资源状态
     */
    selectResourceStateChange(val) {
      this.pageParams.page = 1;
      this.pageParams.total = 0;
      this.isLoading = true;
      this.filters.isShareResource = val == undefined ? "-1" : val;
      this.queryDataByTab("resource");
    },
    /**
     * 筛选数据
     */
    filterData(filters, searchHeight) {
      this.pageParams.page = 1;
      this.pageParams.total = 0;
      this.isLoading = true;
      this.filters = filters;
      this.searchHeight = searchHeight;
      this.queryDataByTab(this.tabsName);
    },
    /**
     * 筛选资源类型
     */
    selectResourceTypeChange() {
      this.pageParams.page = 1;
      this.pageParams.total = 0;
      this.isLoading = true;
      this.queryDataByTab(this.tabsName);
    },
    /**
     * 点击切换详细数据
     */
    changeDataDetailsIndex(name) {
      this.pageParams.page = 1;
      this.pageParams.total = 0;
      this.isLoading = true;
      //点击切换至资源详情
      this.tabsName = name;
      //设置面包屑
      this.setCurrentPathArr();
      //根据不同的tab页请求数据
      this.queryDataByTab(name);
      this.$nextTick(() => {
        if (this.$refs.dataStatistics) {
          this.dataDetailStyle.height =
            705 + this.$refs.dataStatistics.clientHeight + "px";
        }
      });
    },
    /**
     * 根据不同的tab页请求数据
     */
    queryDataByTab(name) {
      this.tabsName = name;
      if (this.schoolId == "0") {
        this.placeholder = "支持学校名称关键字搜索";
      } else {
        if (name === "resource") {
          this.placeholder = "支持资源名称、上传教师关键字搜索";
          this.contentObject.displayGradeFilter = true;
          this.contentObject.displayClassFilter = false;
        } else if (name === "microClassKj") {
          this.placeholder = "支持课件名称、分享教师关键字搜索";
          this.contentObject.displayGradeFilter = true;
          this.contentObject.displayClassFilter = true;
        } else if (name === "microClass") {
          this.placeholder = "支持微课名称、分享教师关键字搜索";
        }
        //点击切换至作业详情
        else if (name === "homework") {
          this.placeholder = "支持作业名称、发送人关键字搜索";
        }
        //点击切换至作业详情
        else if (name === "inquiryLearning") {
          this.placeholder = "支持学习墙名称、发送人关键字搜索";
        }
      }
      this.queryDataBySchoolCode();
    },
    /**
     * 获取分享课件饼图统计
     */
    async getMicroKjDataSummary() {
      let _this = this;
      let params = {
        schoolid: _this.schoolId,
        startdate: _this.filters.startDate,
        enddate: _this.filters.endDate,
        subjectid: _this.filters.subjectId == 0 ? "" : _this.filters.subjectId,
        gradeid: _this.filters.gradeId == 0 ? (_this.filters.phaseGradeIds || "") : _this.filters.gradeId,
        classid: _this.filters.classId == 0 ? "" : _this.filters.classId,
        keyword: _this.listFilters.keyWord,
        isshare:
          _this.listFilters.isShareResource == "-1"
            ? ""
            : _this.listFilters.isShareResource,
      };
      let resultData = await findResourceDataSummary(params).catch(function (
        error
      ) {
        _this.$Message.error(error.message);
      });
      if (Object.keys(resultData).length > 0) {
        _this.dataSummaryMap = [
          {
            key: "课件分享数",
            value: resultData.share_num == null ? 0 : resultData.share_num,
            remindText: "教师分享课件的总次数",
          },
          {
            key: "课件接收数",
            value: resultData.receive_num == null ? 0 : resultData.receive_num,
            remindText: "教师分享课件接收人次的总和",
          },
          {
            key: "课件查看数",
            value: resultData.read_num == null ? 0 : resultData.read_num,
            remindText: "接收课件人次中查看人次的总和",
          },
          {
            key: "课件查看率",
            value:
              resultData.read_rate == null
                ? 0 + "%"
                : _this.$utils
                  .toDecimal(resultData.read_rate * 100)
                  .toString() + "%",
            remindText: "（“课件查看数”/“课件接收数”）*100%",
          },
          {
            key: "课件看懂率",
            value:
              resultData.understand_rate == null
                ? 0 + "%"
                : _this.$utils
                  .toDecimal(resultData.understand_rate * 100)
                  .toString() + "%",
            remindText: "（“看懂课件数”/“课件查看数”）*100%",
          },
        ];
      } else {
        _this.dataSummaryMap = [
          {
            key: "课件分享数",
            value: 0,
            remindText: "教师分享课件的总次数",
          },
          {
            key: "课件接收数",
            value: 0,
            remindText: "教师分享课件接收人次的总和",
          },
          {
            key: "课件查看数",
            value: 0,
            remindText: "接收课件人次中查看人次的总和",
          },
          {
            key: "课件查看率",
            value: 0 + "%",
            remindText: "（“课件查看数”/“课件接收数”）*100%",
          },
          {
            key: "课件看懂率",
            value: 0 + "%",
            remindText: "（“看懂课件数”/“课件查看数”）*100%",
          },
        ];
      }
    },
    /**
     * 获取资源饼图统计
     */
    async getResourceDataSummary() {
      let _this = this;
      let params = {
        schoolId: _this.schoolId,
        resourceType:
          _this.listFilters.resourceType == 0
            ? ""
            : _this.listFilters.resourceType,
        startDate: _this.filters.startDate,
        endDate: _this.filters.endDate,
        subjectId: _this.filters.subjectId == 0 ? "" : _this.filters.subjectId,
        keyWord: _this.listFilters.keyWord,
        isShare:
          _this.listFilters.isShareResource == "-1"
            ? ""
            : _this.listFilters.isShareResource,
        gradeId: this.filters.gradeId == 0 ? (this.filters.phaseGradeIds || "") : this.filters.gradeId,
      };
      let resultData = await findUploadResourceSummary(params).catch(function (
        error
      ) {
        _this.$Message.error(error.message);
      });
      if (Object.keys(resultData).length > 0) {
        _this.dataSummaryMap = [
          {
            key: "课件上传数",
            value:
              resultData.coursewareCount == null
                ? 0
                : resultData.coursewareCount,
            remindText: "教师上传至网盘的课件总数",
          },
          {
            key: "微课上传数",
            value:
              resultData.microclassCount == null
                ? 0
                : resultData.microclassCount,
            remindText: "教师上传至网盘的微课总数",
          },
        ];
      } else {
        _this.dataSummaryMap = [
          {
            key: "课件上传数",
            value: 0,
            remindText: "教师上传至网盘的课件总数",
          },
          {
            key: "微课上传数",
            value: 0,
            remindText: "教师上传至网盘的微课总数",
          },
        ];
      }
    },
    /**
     * 获取微课饼图统计
     */
    async getMicroDataSummary() {
      let _this = this;
      let params = {
        schoolid: _this.schoolId,
        startdate: _this.filters.startDate,
        enddate: _this.filters.endDate,
        subjectid: _this.filters.subjectId == 0 ? "" : _this.filters.subjectId,
        gradeid: _this.filters.gradeId == 0 ? (_this.filters.phaseGradeIds || "") : _this.filters.gradeId,
        classid: _this.filters.classId == 0 ? "" : _this.filters.classId,
        keyword: _this.listFilters.keyWord,
      };
      let resultData = await findMicroDataSummary(params).catch(function (
        error
      ) {
        _this.$Message.error(error.message);
      });
      if (Object.keys(resultData).length > 0) {
        _this.dataSummaryMap = [
          {
            key: "微课分享数",
            value: resultData.share_num == null ? 0 : resultData.share_num,
            remindText: "教师分享微课的总次数",
          },
          {
            key: "微课接收数",
            value: resultData.receive_num == null ? 0 : resultData.receive_num,
            remindText: "教师分享微课接收人次的总和",
          },
          {
            key: "微课查看数",
            value: resultData.read_num == null ? 0 : resultData.read_num,
            remindText: "接收微课人次中查看人次的总和",
          },
          {
            key: "微课查看率",
            value:
              resultData.read_rate == null
                ? 0 + "%"
                : _this.$utils
                  .toDecimal(resultData.read_rate * 100)
                  .toString() + "%",
            remindText: "（“微课查看数”/“微课接收数”）*100%",
          },
          {
            key: "微课看懂率",
            value:
              resultData.understand_rate == null
                ? 0 + "%"
                : _this.$utils
                  .toDecimal(resultData.understand_rate * 100)
                  .toString() + "%",
            remindText: "（“看懂微课数”/“微课查看数”）*100%",
          },
        ];
      } else {
        _this.dataSummaryMap = [
          {
            key: "微课分享数",
            value: 0,
            remindText: "教师分享微课的总次数",
          },
          {
            key: "微课接收数",
            value: 0,
            remindText: "教师分享微课接收人次的总和",
          },
          {
            key: "微课查看数",
            value: 0,
            remindText: "接收微课人次中查看人次的总和",
          },
          {
            key: "微课查看率",
            value: 0 + "%",
            remindText: "（“微课查看数”/“微课接收数”）*100%",
          },
          {
            key: "微课看懂率",
            value: 0 + "%",
            remindText: "（“看懂微课数”/“微课查看数”）*100%",
          },
        ];
      }
    },
    /**
     * 获取探究学习墙饼图统计
     */
    async getInquiryDataSummary() {
      let _this = this;
      let params = {
        schoolid: _this.schoolId,
        startdate: _this.filters.startDate,
        enddate: _this.filters.endDate,
        subjectid: _this.filters.subjectId == 0 ? "" : _this.filters.subjectId,
        gradeid: _this.filters.gradeId == 0 ? (_this.filters.phaseGradeIds || "") : _this.filters.gradeId,
        classid: _this.filters.classId == 0 ? "" : _this.filters.classId,
        keyword: _this.listFilters.keyWord,
      };
      let resultData = await findInquirySummary(params).catch(function (error) {
        _this.$Message.error(error.message);
      });
      if (Object.keys(resultData).length > 0) {
        _this.dataSummaryMap = [
          {
            key: "发送次数",
            value: resultData.sendNum == null ? 0 : resultData.sendNum,
            remindText: "老师发送探究学习的总次数",
          },
          {
            key: "动态数量",
            value: resultData.dynamicNum == null ? 0 : resultData.dynamicNum,
            remindText: "每一个探究学习动态数量的总和",
          },
          {
            key: "接收人数",
            value: resultData.receive_num == null ? 0 : resultData.receive_num,
            remindText: "每一个探究学习接收人数的总和",
          },
          {
            key: "参与人数",
            value: resultData.partakeNum == null ? 0 : resultData.partakeNum,
            remindText: "每一个探究学习参与人数的总和",
          },
          {
            key: "参与率",
            value:
              resultData.partakeRate == null
                ? 0 + "%"
                : _this.$utils
                  .toDecimal(resultData.partakeRate * 100)
                  .toString() + "%",
            remindText: "参与人数/接收人数*100%",
          },
        ];
      } else {
        _this.dataSummaryMap = [
          {
            key: "发送次数",
            value: 0,
            remindText: "老师发送探究学习的总次数",
          },
          {
            key: "动态数量",
            value: 0,
            remindText: "每一个探究学习动态数量的总和",
          },
          {
            key: "接收人数",
            value: 0,
            remindText: "每一个探究学习接收人数的总和",
          },
          {
            key: "参与人数",
            value: 0,
            remindText: "每一个探究学习参与人数的总和",
          },
          {
            key: "参与率",
            value: 0 + "%",
            remindText: "参与人数/接收人数*100%",
          },
        ];
      }
    },
    /**
     * 获取作业饼图统计
     */
    async homeWorkNumMap() {
      let _this = this;
      let params = {
        schoolid: _this.schoolId,
        startdate: _this.filters.startDate,
        enddate: _this.filters.endDate,
        subjectid: _this.filters.subjectId == 0 ? "" : _this.filters.subjectId,
        gradeid: _this.filters.gradeId == 0 ? (_this.filters.phaseGradeIds || "") : _this.filters.gradeId,
        classid: _this.filters.classId == 0 ? "" : _this.filters.classId,
        hwTypeCode: _this.listFilters.hwType,
        keyword: _this.listFilters.keyWord,
      };
      let resultData = await findHomeworkSummary(params).catch(function (
        error
      ) {
        _this.$Message.error(error.message);
      });
      if (Object.keys(resultData).length > 0) {
        _this.dataSummaryMap = [
          {
            key: "作业布置总数",
            value:
              resultData.hw_total_num == null ? 0 : resultData.hw_total_num,
            remindText: "老师发送的作业次数",
          },
          {
            key: "接收人数",
            value: resultData.stuNum == null ? 0 : resultData.stuNum,
            remindText: "每次作业接收人数的总和",
          },
          {
            key: "提交人数",
            value: resultData.hwSubmitNum == null ? 0 : resultData.hwSubmitNum,
            remindText: "每次作业提交人数的总和",
          },
          {
            key: "批改作业数",
            value:
              resultData.hwCorrectNum == null ? 0 : resultData.hwCorrectNum,
            remindText: "每次作业老师批改作业的总数",
          },
          {
            key: "作业提交率",
            value:
              resultData.hwSubmitRate == null
                ? 0 + "%"
                : _this.$utils
                  .toDecimal(resultData.hwSubmitRate * 100)
                  .toString() + "%",
            remindText: "提交人数/接收人数*100%",
          },
          {
            key: "作业批改率",
            value:
              resultData.hwCorrectRate == null
                ? 0 + "%"
                : _this.$utils
                  .toDecimal(resultData.hwCorrectRate * 100)
                  .toString() + "%",
            remindText: "批改作业数/提交人数*100%",
          },
        ];
      } else {
        _this.dataSummaryMap = [
          {
            key: "作业布置数",
            value: 0,
            remindText: "老师发送的作业次数",
          },
          {
            key: "接收人数",
            value: 0,
            remindText: "每次作业接收人数的总和",
          },
          {
            key: "提交人数",
            value: 0,
            remindText: "每次作业提交人数的总和",
          },
          {
            key: "作业批改数",
            value: 0,
            remindText: "每次作业老师批改作业的总数",
          },
          {
            key: "作业提交率",
            value: 0 + "%",
            remindText: "提交人数/接收人数*100%",
          },
          {
            key: "作业批改率",
            value: 0 + "%",
            remindText: "批改作业数/提交人数*100%",
          },
        ];
      }
    },
    /**
     * 获取资源列表
     */
    async getResourceList() {
      let _this = this;
      let params = {
        schoolId: _this.schoolId,
        resourceType:
          _this.listFilters.resourceType == 0
            ? ""
            : _this.listFilters.resourceType,
        startDate: _this.filters.startDate,
        endDate: _this.filters.endDate,
        subjectId: _this.filters.subjectId == 0 ? "" : _this.filters.subjectId,
        pageNo: _this.pageParams.page,
        pageSize: _this.pageParams.limit,
        keyWord: _this.listFilters.keyWord,
        isShare:
          _this.listFilters.isShareResource == "-1"
            ? ""
            : _this.listFilters.isShareResource,
        order: _this.schoolResDataOrder,
        gradeId: this.filters.gradeId == 0 ? (this.filters.phaseGradeIds || "") : this.filters.gradeId,
      };
      let resultData = await findResourceNewList(params).catch(function (
        error
      ) {
        _this.$Message.error(error.message);
      });
      //隐藏加载中样式
      _this.isLoading = false;
      _this.resourceList = [];
      _this.pageParams.total = 0;
      if (Object.keys(resultData).length > 0) {
        _this.resourceList = resultData.rows;
        _this.pageParams.total = resultData.total_rows;
        _this.pageParams.pageCount = resultData.page_count;
        _this.$nextTick(() => {
          _this.dataDetailStyle.height =
            _this.searchHeight +
            _this.$refs.tabChangeRef.clientHeight +
            _this.$refs.dataStatistics.clientHeight +
            _this.$refs.tableMainRef.clientHeight +
            30 +
            "px";
        });
      }
    },
    /**
     * 获取分享课件列表
     */
    async getShareCoursewareList() {
      let _this = this;
      let params = {
        schoolId: _this.schoolId,
        startDate: _this.filters.startDate,
        endDate: _this.filters.endDate,
        subjectId: _this.filters.subjectId == 0 ? "" : _this.filters.subjectId,
        schoolYear: "",
        gradeId: _this.filters.gradeId == 0 ? (_this.filters.phaseGradeIds || "") : _this.filters.gradeId,
        classId: _this.filters.classId == 0 ? "" : _this.filters.classId,
        pageNo: _this.pageParams.page,
        pageSize: _this.pageParams.limit,
        keyWord: _this.listFilters.keyWord,
        shareType: 1,
        order: _this.schoolMicroKjDataOrder,
      };
      let resultData = await findShareCoursewareList(params).catch(function (
        error
      ) {
        _this.$Message.error(error.message);
      });
      //隐藏加载中样式
      _this.isLoading = false;
      _this.microKjList = [];
      _this.pageParams.total = 0;
      if (Object.keys(resultData).length > 0) {
        _this.microKjList = resultData.rows;
        _this.pageParams.total = resultData.total_rows;
        _this.pageParams.pageCount = resultData.page_count;
        _this.$nextTick(() => {
          _this.dataDetailStyle.height =
            _this.searchHeight +
            _this.$refs.tabChangeRef.clientHeight +
            _this.$refs.dataStatistics.clientHeight +
            _this.$refs.tableMainRef.clientHeight +
            30 +
            "px";
        });
      }
    },
    /**
     * 获取微课列表
     */
    async getCoursewaresInfoList() {
      let _this = this;
      let params = {
        schoolid: _this.schoolId,
        startdate: _this.filters.startDate,
        enddate: _this.filters.endDate,
        subjectid: _this.filters.subjectId == 0 ? "" : _this.filters.subjectId,
        gradeid: _this.filters.gradeId == 0 ? (_this.filters.phaseGradeIds || "") : _this.filters.gradeId,
        classid: _this.filters.classId == 0 ? "" : _this.filters.classId,
        pageno: _this.pageParams.page,
        pagesize: _this.pageParams.limit,
        keyword: _this.listFilters.keyWord,
        isshare:
          _this.listFilters.isShareMicro == "0"
            ? ""
            : _this.listFilters.isShareMicro,
        order: _this.schoolMicroDataOrder,
      };
      let resultData = await findMicroList(params).catch(function (error) {
        _this.$Message.error(error.message);
      });
      //隐藏加载中样式
      _this.isLoading = false;
      _this.microList = [];
      _this.pageParams.total = 0;
      if (Object.keys(resultData).length > 0) {
        _this.microList = resultData.rows;
        _this.pageParams.total = resultData.total_rows;
        _this.pageParams.pageCount = resultData.page_count;
        _this.$nextTick(() => {
          _this.dataDetailStyle.height =
            _this.searchHeight +
            _this.$refs.tabChangeRef.clientHeight +
            _this.$refs.dataStatistics.clientHeight +
            _this.$refs.tableMainRef.clientHeight +
            30 +
            "px";
        });
      }
    },
    /**
     * 获取探究学习墙列表
     */
    async getInquiryList() {
      let _this = this;
      let params = {
        schoolid: _this.schoolId,
        startdate: _this.filters.startDate,
        enddate: _this.filters.endDate,
        subjectid: _this.filters.subjectId == 0 ? "" : _this.filters.subjectId,
        gradeid: _this.filters.gradeId == 0 ? (_this.filters.phaseGradeIds || "") : _this.filters.gradeId,
        classid: _this.filters.classId == 0 ? "" : _this.filters.classId,
        pageno: _this.pageParams.page,
        pagesize: _this.pageParams.limit,
        keyword: _this.listFilters.keyWord,
        order: _this.schoolLearnDataOrder,
      };
      let resultData = await findInquiryList(params).catch(function (error) {
        _this.$Message.error(error.message);
      });
      //隐藏加载中样式
      _this.isLoading = false;
      _this.learnList = [];
      _this.pageParams.total = 0;
      if (Object.keys(resultData).length > 0) {
        _this.learnList = resultData.rows;
        _this.pageParams.total = resultData.total_rows;
        _this.pageParams.pageCount = resultData.page_count;
        _this.$nextTick(() => {
          _this.dataDetailStyle.height =
            _this.searchHeight +
            _this.$refs.tabChangeRef.clientHeight +
            _this.$refs.dataStatistics.clientHeight +
            _this.$refs.tableMainRef.clientHeight +
            30 +
            "px";
        });
      }
    },
    /**
     * 获取作业列表
     */
    async getHomeworkList() {
      let _this = this;
      let params = {
        schoolid: _this.schoolId,
        keyword: _this.listFilters.keyWord,
        startdate: _this.filters.startDate,
        enddate: _this.filters.endDate,
        pageno: _this.pageParams.page,
        pagesize: _this.pageParams.limit,
        subjectid: _this.filters.subjectId == 0 ? "" : _this.filters.subjectId,
        gradeid: _this.filters.gradeId == 0 ? (_this.filters.phaseGradeIds || "") : _this.filters.gradeId,
        classid: _this.filters.classId == 0 ? "" : _this.filters.classId,
        hwTypeCode: _this.listFilters.hwType,
        order: _this.schoolHwDataOrder,
        // schoolyear: _this.filters.classyear,
      };
      let resultData = await findHwDetail(params).catch(function (error) {
        _this.$Message.error(error.message);
      });
      //隐藏加载中样式
      _this.isLoading = false;
      _this.homeworkList = [];
      _this.pageParams.total = 0;
      if (Object.keys(resultData).length > 0) {
        _this.homeworkList = resultData.rows;
        _this.pageParams.total = resultData.total_rows;
        _this.pageParams.pageCount = resultData.page_count;
        _this.$nextTick(() => {
          _this.dataDetailStyle.height =
            _this.searchHeight +
            _this.$refs.tabChangeRef.clientHeight +
            _this.$refs.dataStatistics.clientHeight +
            _this.$refs.tableMainRef.clientHeight +
            30 +
            "px";
        });
      }
    },
    /**
     * 获取全部的数据概览
     */
    async getTotalDataBySchool() {
      let _this = this;
      let params = {
        schoolid: _this.schoolId,
        keyword: _this.listFilters.keyWord,
        pageno: _this.pageParams.page,
        pagesize: _this.pageParams.limit,
        type:
          _this.filters.timeSolt == 4
            ? 3
            : _this.filters.timeSolt == 0
              ? ""
              : _this.filters.timeSolt,
        provinceId:
          _this.filters.provinceId == "0" ? "" : _this.filters.provinceId,
        cityId: _this.filters.cityId == "0" ? "" : _this.filters.cityId,
        districtId:
          _this.filters.districtId == "0" ? "" : _this.filters.districtId,
      };
      let resultData = await findTotalDataBySchool(params).catch(function (
        error
      ) {
        _this.$Message.error(error.message);
      });
      _this.dataSummaryMap = [];
      if (_this.tabsName == "resource") {
        _this.dataSummaryMap = [
          {
            key: "资源上传数",
            value:
              resultData[0].rs_upload_num == null
                ? 0
                : resultData[0].rs_upload_num,
            remindText: "老师上传至网盘的资源总数",
          },
          {
            key: "资源分享数",
            value:
              resultData[0].rs_share_num == null
                ? 0
                : resultData[0].rs_share_num,
            remindText: "老师分享资源的总次数",
          },
          {
            key: "资源查看数",
            value:
              resultData[0].rs_read_num == null ? 0 : resultData[0].rs_read_num,
            remindText: "每份资源的看懂人数和未看懂人数的总和",
          },
          {
            key: "学生查看率",
            value:
              resultData[0].rs_read_rate == null
                ? 0 + "%"
                : _this.$utils
                  .toDecimal(resultData[0].rs_read_rate * 100)
                  .toString() + "%",
            remindText: "(看懂人数+未看懂人数)/接收到资源的人数*100%",
          },
          {
            key: "学生看懂率",
            value:
              resultData[0].rs_understand_rate == null
                ? 0 + "%"
                : _this.$utils
                  .toDecimal(resultData[0].rs_understand_rate * 100)
                  .toString() + "%",
            remindText: "看懂人数/已看人数*100%",
          },
        ];
      } else if (_this.tabsName == "microClass") {
        _this.dataSummaryMap = [
          {
            key: "微课上传数",
            value:
              resultData[0].cw_upload_num == null
                ? 0
                : resultData[0].cw_upload_num,
            remindText: "老师上传至网盘的微课总数",
          },
          {
            key: "微课分享数",
            value:
              resultData[0].cw_share_num == null
                ? 0
                : resultData[0].cw_share_num,
            remindText: "老师分享微课的总次数",
          },
          {
            key: "微课查看数",
            value:
              resultData[0].cw_read_num == null ? 0 : resultData[0].cw_read_num,
            remindText: "每份微课的看懂人数和未看懂人数的总和",
          },
          {
            key: "学生查看率",
            value:
              resultData[0].cw_read_rate == null
                ? 0 + "%"
                : _this.$utils
                  .toDecimal(resultData[0].cw_read_rate * 100)
                  .toString() + "%",
            remindText: "(看懂人数+未看懂人数)/接收到微课的人数*100%",
          },
          {
            key: "学生看懂率",
            value:
              resultData[0].cw_understand_rate == null
                ? 0 + "%"
                : _this.$utils
                  .toDecimal(resultData[0].cw_understand_rate * 100)
                  .toString() + "%",
            remindText: "看懂人数/已看人数*100%",
          },
        ];
      } else if (_this.tabsName == "homework") {
        _this.dataSummaryMap = [
          {
            key: "作业布置数",
            value:
              resultData[0].tea_hw_num == null ? 0 : resultData[0].tea_hw_num,
            remindText: "老师已发送的作业次数",
          },
          {
            key: "提交人数",
            value:
              resultData[0].hw_submit_num == null
                ? 0
                : resultData[0].hw_submit_num,
            remindText: "每次作业提交人数的总和",
          },
          {
            key: "作业批改数",
            value:
              resultData[0].hw_correct_num == null
                ? 0
                : resultData[0].hw_correct_num,
            remindText: "每次作业老师批改作业的总数",
          },
          {
            key: "作业提交率",
            value:
              resultData[0].hw_submi_rate == null
                ? 0 + "%"
                : _this.$utils
                  .toDecimal(resultData[0].hw_submi_rate * 100)
                  .toString() + "%",
            remindText: "提交人数/接收人数*100%",
          },
          {
            key: "作业批改率",
            value:
              resultData[0].hw_correct_rate == null
                ? 0 + "%"
                : _this.$utils
                  .toDecimal(resultData[0].hw_correct_rate * 100)
                  .toString() + "%",
            remindText: "批改作业数/提交人数*100%",
          },
        ];
      } else if (_this.tabsName == "inquiryLearning") {
        _this.dataSummaryMap = [
          {
            key: "发送次数",
            value:
              resultData[0].inquiry_send_num == null
                ? 0
                : resultData[0].inquiry_send_num,
            remindText: "老师发送探究学习的总次数",
          },
          {
            key: "动态数量",
            value:
              resultData[0].inquiry_dynamic_num == null
                ? 0
                : resultData[0].inquiry_dynamic_num,
            remindText: "每一个探究学习动态数量的总和",
          },
          {
            key: "参与人数",
            value:
              resultData[0].inquiry_partake_num == null
                ? 0
                : resultData[0].inquiry_partake_num,
            remindText: "每一个探究学习参与人数的总和",
          },
          {
            key: "参与率",
            value:
              resultData[0].inquiry_partake_rate == null
                ? 0 + "%"
                : _this.$utils
                  .toDecimal(resultData[0].inquiry_partake_rate * 100)
                  .toString() + "%",
            remindText: "参与人数/接收人数*100%",
          },
        ];
      }
    },
    /**
     * 获取全部的作业资源和微课数据
     */
    async getTotalStaticsBySchool() {
      let _this = this;
      let order = _this.handleOrderData();
      let params = {
        schoolid: _this.schoolId,
        keyword: _this.listFilters.keyWord,
        pageno: _this.pageParams.page,
        pagesize: _this.pageParams.limit,
        type:
          _this.filters.timeSolt == 4
            ? 3
            : _this.filters.timeSolt == 0
              ? ""
              : _this.filters.timeSolt,
        provinceId:
          _this.filters.provinceId == "0" ? "" : _this.filters.provinceId,
        cityId: _this.filters.cityId == "0" ? "" : _this.filters.cityId,
        districtId:
          _this.filters.districtId == "0" ? "" : _this.filters.districtId,
        order: order,
      };
      let resultData = await findTotalBySchool(params).catch(function (error) {
        _this.$Message.error(error.message);
      });
      _this.isLoading = false;
      _this.totalDataList = [];
      _this.pageParams.total = 0;
      if (Object.keys(resultData).length > 0) {
        _this.totalDataList = resultData.rows;
        _this.pageParams.total = resultData.total_rows;
        _this.pageParams.pageCount = resultData.page_count;
        _this.$nextTick(() => {
          _this.dataDetailStyle.height =
            _this.searchHeight +
            _this.$refs.tabChangeRef.clientHeight +
            _this.$refs.dataStatistics.clientHeight +
            _this.$refs.tableMainRef.clientHeight +
            30 +
            "px";
        });
      }
    },
    /**
     * 处理排序
     */
    handleOrderData() {
      let order = "";
      switch (this.tabsName) {
        case "homework":
          order = this.tolHwDataOrder;
          return order;
        case "resource":
          order = this.tolResDataOrder;
          return order;
        case "microClass":
          order = this.tolMicroDataOrder;
          return order;
        case "inquiryLearning":
          order = this.tolLearnDataOrder;
          return order;
      }
    },
    /**
     * 获取作业类型
     */
    async getHwTypeCodeList() {
      let _this = this;
      let params = {
        schoolId: _this.schoolId,
      };
      let resultData = await findHwTypeCodeList(params).catch(function (error) {
        _this.$Message.error(error.message);
      });
      _this.hwTypeList = resultData;
    },

    /**
     * 翻页
     */
    handleCurrentChange(val) {
      this.pageParams.page = val;
      this.isLoading = true;
      this.queryDataBySchoolCode();
    },
    /**
     * 查询
     */
    handleSearch() {
      this.pageParams.total = 0;
      this.pageParams.page = 1;
      this.pageParams.pageCount = 0;
      this.isLoading = true;
      this.queryDataBySchoolCode();
    },
    /**
     * 点击查看作业报告
     */
    lookWorkReport(userId, homeworkId, homeworkName, hwType, hwTypeCode) {
      let reportUrl = "";
      //答题卡
      if (hwType == 0) {
        // 包含 201 202 203 100(旧版本自定义)
        reportUrl =
          this.homeWorkReportPath +
          "/report/" +
          userId +
          "/" +
          homeworkId +
          "/" +
          homeworkName +
          "/" +
          hwType +
          "/web?hwtypecode=" +
          hwTypeCode +
          "&subjectId=" +
          this.hwUserSubjectId;
      } else if (hwType == 1) {
        if (hwTypeCode == "103") {
          //菁优题库
          reportUrl =
            this.homeWorkReportPath +
            "/jingyouReport/" +
            userId +
            "/" +
            homeworkId +
            "/" +
            homeworkName +
            "/" +
            hwType +
            "/web?hwtypecode=" +
            hwTypeCode +
            "&subjectId=" +
            this.hwUserSubjectId;
        } else if (hwTypeCode == "104" || hwTypeCode == "110") {
          //校本题库
          reportUrl =
            this.homeWorkReportPath +
            "/xbReport/" +
            userId +
            "/" +
            homeworkId +
            "/" +
            homeworkName +
            "/" +
            hwType +
            "/web?hwtypecode=" +
            hwTypeCode +
            "&subjectId=" +
            this.hwUserSubjectId;
        } else if (hwTypeCode == "108") {
          //学科网
          reportUrl =
            this.homeWorkReportPath +
            "/xkwReport/" +
            userId +
            "/" +
            homeworkId +
            "/" +
            homeworkName +
            "/" +
            hwType +
            "/web?hwtypecode=" +
            hwTypeCode +
            "&subjectId=" +
            this.hwUserSubjectId;
        } else {
          //题库
          reportUrl =
            this.homeWorkReportPath +
            "/questionBankReport/" +
            userId +
            "/" +
            homeworkId +
            "/" +
            homeworkName +
            "/" +
            hwType +
            "/web?hwtypecode=" +
            hwTypeCode +
            "&subjectId=" +
            this.hwUserSubjectId;
        }
      }
      window.open(reportUrl, "_blank");
    },
    /**
     * 根据用户id查询学科id
     */
    async findUserSubjectByUserId(
      userId,
      homeworkId,
      homeworkName,
      hwType,
      hwTypeCode
    ) {
      let _this = this;
      let userParam = {
        userId: userId,
      };

      let userData = await findUserInfo(userParam).catch(function (error) {
        _this.$Message.error(error.message);
      });

      _this.hwUserSubjectId = userData.subjectid;
      //点击查看作业报告
      _this.lookWorkReport(
        userId,
        homeworkId,
        homeworkName,
        hwType,
        hwTypeCode
      );
    },
    /**
     * 学习墙
     */
    openStudyBoard(rows) {
      let url =
        process.env.VUE_APP_STUDYBOARD +
        rows.tea_id +
        "/publish_" +
        rows.inquiry_id +
        "?demoMode=1&userid=" +
        this.$store.getters.userId +
        "&schoolId=" +
        this.schoolId;
      window.open(url, "_blank");
    },
    /**
     * 关闭弹窗
     */
    closeWin() {
      this.isShowModal = false;
    },
    /**
     * 预览资源
     */
    async openPreview(id, resultUrl, count, type, index, fromType, workId) {
      let resultUrls;
      let res;
      try {
        if (workId) {
          res = await findResourceInfo({ id: workId });
          resultUrls = res.resultUrl;
        } else {
          if (!/http/g.test(resultUrl)) {
            // type 0:其他 1.文档 2.视频 3.音频 4.图片
            resultUrls = "https://fs.iclass30.com/" + resultUrl;
          }
        }
        if (type === 2) {
          this.previewVideoMode = true;
          this.videoSrc = resultUrls + "/video.mp4";
          return;
        } else if (type === 3) {
          this.$set(this.resourceList[index], "isPlaying", 1);
          return;
        }
        if (!count) {
          this.$Message.error("暂无缩略图，无法预览！");
          return;
        }
        this.previewMode = true;

        this.$refs.previewSlider.swiperInit(resultUrls, count);
      } catch (error) {
        console.error(error);
      }
    },
    // 关闭预览
    closePreview(type) {
      this[type] = false;
    },
    /**
     * 查看各校的数据展板
     */
    lookSchoolDataBoard(rows) {
      let routeData = this.$router.resolve({
        name:
          rows.school_id == "75047a8a0990480f8abf3a39bc25f1ab"
            ? "cloudschooldataboard"
            : "schooldataboard",
        params: {
          schoolId: rows.school_id,
        },
        query: {
          tokenId: this.$store.getters.token,
        },
      });
      window.open(routeData.href, "_blank");
    },
    /**
     * 排序
     */
    sortData(sortType) {
      let data = [];
      if (this.tabsName == "homework") {
        data =
          this.$route.params.schoolId != 0
            ? this.schoolHwDataSortArr
            : this.tolHwDataSortArr;
      } else if (this.tabsName == "resource") {
        data =
          this.$route.params.schoolId != 0
            ? this.schoolResDataSortArr
            : this.tolResDataSortArr;
      } else if (this.tabsName == "microClass") {
        data =
          this.$route.params.schoolId != 0
            ? this.schoolMicroDataSortArr
            : this.tolMicroDataSortArr;
      } else {
        data =
          this.$route.params.schoolId != 0
            ? this.schoolLearnDataSortArr
            : this.tolLearnDataSortArr;
      }
      for (let i = 0; i < data.length; i++) {
        if (data[i].sortType == sortType) {
          data[i].orderType = data[i].orderType == "desc" ? "asc" : "desc";
          if (this.tabsName == "homework") {
            if (this.$route.params.schoolId != 0) {
              this.schoolHwDataOrder =
                data[i].sortType + " " + data[i].orderType;
            } else {
              this.tolHwDataOrder = data[i].sortType + " " + data[i].orderType;
            }
          } else if (this.tabsName == "resource") {
            if (this.$route.params.schoolId != 0) {
              this.schoolResDataOrder =
                data[i].sortType + " " + data[i].orderType;
            } else {
              this.tolResDataOrder = data[i].sortType + " " + data[i].orderType;
            }
          } else if (this.tabsName == "microClass") {
            if (this.$route.params.schoolId != 0) {
              this.schoolMicroDataOrder =
                data[i].sortType + " " + data[i].orderType;
            } else {
              this.tolMicroDataOrder =
                data[i].sortType + " " + data[i].orderType;
            }
          } else {
            if (this.$route.params.schoolId != 0) {
              this.schoolLearnDataOrder =
                data[i].sortType + " " + data[i].orderType;
            } else {
              this.tolLearnDataOrder =
                data[i].sortType + " " + data[i].orderType;
            }
          }
        }
      }
      this.pageParams.page = 1;
      this.queryDataBySchoolCode();
    },
    /**
     * 表格斑马纹
     */
    rowClassName(row, index) {
      if (index % 2 == 0) {
        return "ivu-table-stripe-even";
      } else return "ivu-table-stripe-odd";
    },
    /**
     * 根据schoolCode获取不同的数据
     */
    queryDataBySchoolCode() {
      if (this.$route.params.schoolId != 0) {
        if (this.tabsName == "resource") {
          this.getResourceList();
          this.getResourceDataSummary();
        } else if (this.tabsName == "homework") {
          //作业详情
          this.getHomeworkList();
          this.homeWorkNumMap();
        } else if (this.tabsName == "microClass") {
          //微课详情
          this.getCoursewaresInfoList();
          this.getMicroDataSummary();
        } else if (this.tabsName == "microClassKj") {
          //分享课件详情
          this.getShareCoursewareList();
          this.getMicroKjDataSummary();
        } else if (this.tabsName == "inquiryLearning") {
          //探究学习墙详情
          this.getInquiryList();
          this.getInquiryDataSummary();
        }
      } else {
        this.getTotalDataBySchool();
        this.getTotalStaticsBySchool();
      }
    },
    /**
     * 打开线下作业数
     */
    openBigDataPath() {
      window.open(`https://gc.iclass30.com/bigdata/home/supervise/overview?token=${this.$store.getters.token}`, "_blank");
    }
  },
  mounted() {
    if (this.$route.params.schoolId != 0) {
      this.getHwTypeCodeList();
    }
  },
};
</script>

<style lang="scss" scoped>
@import "../../../../style/detailPage";

.circle-data {
  background: url("../../../../assets/images/databoard/detailPage/green-circle.png") top no-repeat;
}

.panel-box {
  background-image: url("../../../../assets/images/databoard/modal-bg.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

.big-data-search-btn {
  background: #00caaf !important;
  color: #fff;
  border-color: #00caaf !important;
}

/*图片预览遮罩层*/
.img-ml-box {
  position: fixed;
  top: 0px;
  height: 100%;
  left: 0px;
  right: 0px;
  bottom: 0px;
  width: 100%;
  z-index: 50;
  display: none;
}

/*遮罩层背景*/
.img-ml-box .img-ml-bg {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0px;
  top: 0px;
  right: 0px;
  bottom: 0px;
  background: #000;
  opacity: 0.8;
  z-index: 55;
}

/*关闭按钮*/
.img-ml-box .img-ml-close {
  position: absolute;
  right: 15px;
  top: 10px;
  width: 32px;
  height: 32px;
  z-index: 999;
  opacity: 0.6;
  background: url("../../../../assets/images/databoard/close.png") center center no-repeat;
}

.img-ml-box .img-ml-close:hover {
  opacity: 1;
}

.audio-player-container {
  position: absolute;
  z-index: 70;
  top: 44%;
  left: 50%;
  width: 70%;
  max-width: 1200px;
  padding: 33px 80px 33px 156px;
  margin: 0 auto;
  display: block;
  background-color: #fff;
  border-radius: 5px;
  -webkit-transform: translate3d(-50%, -50%, 0);
  -moz-transform: translate3d(-50%, -50%, 0);
  -ms-transform: translate3d(-50%, -50%, 0);
  -o-transform: translate3d(-50%, -50%, 0);
  transform: translate3d(-50%, -50%, 0);
  display: none;
}

.audio-player-container .audio-progress {
  width: 100%;
  height: 24px;
  background: rgba(239, 241, 250, 1);
  border: 1px solid rgba(232, 234, 244, 1);
  border-radius: 12px;
  overflow: hidden;
}

.audio-player-container .audio-progress .audio-progress-bar {
  height: 100%;
  background: rgba(62, 115, 246, 1);
  border-radius: 12px;
}

.audio-player-container .play-btn {
  position: absolute;
  top: 21px;
  left: 71px;
  width: 50px;
  height: 50px;
  background: url("../../../../assets/images/databoard/icon-audioplayer.png") no-repeat;
  cursor: pointer;
}

.audio-player-container .play-btn:active {
  opacity: 0.6;
}

.audio-player-container .play-btn.play {
  background-position: 1px 1px;
}

.audio-player-container .play-btn.pause {
  background-position: 1px -64px;
}

// .tab-content{
//   height: vw(613);
// }
.new-data-tab-area {
  position: relative;
.hwNum-btn{
  position: absolute;
  top: 4px;
  right: 20px;
}
}
</style>

<style lang="scss">
.new-data-tab-area {
  .ivu-tabs-bar {
    border-bottom: 0;
    background: #f2f5f3;
  }

  .ivu-tabs.ivu-tabs-card>.ivu-tabs-bar .ivu-tabs-nav-container {
    height: 40px;
  }

  .ivu-tabs.ivu-tabs-card>.ivu-tabs-bar .ivu-tabs-tab {
    height: 40px;
    margin-right: 1px;
    padding: 9px 16px 4px;
  }

  .ivu-tabs.ivu-tabs-card>.ivu-tabs-bar .ivu-tabs-tab-active {
    height: 40px;
    color: #00caaf;
  }

  .ivu-tabs-nav .ivu-tabs-tab:hover {
    color: #00caaf;
  }

  .ivu-tabs-nav-container:focus .ivu-tabs-tab-focused {
    border-color: #dcdee2 !important;
  }
}

.table-main {

  /*偶数行*/
  .ivu-table-stripe-even td {
    background-color: #fff !important;
  }

  /*奇数行*/
  .ivu-table-stripe-odd td {
    background-color: #fafbfd !important;
  }

  .ivu-table th {
    background-color: #f3f7f6;
    height: 50px !important;
    font-weight: bold;
    white-space: nowrap;
  }

  .ivu-table td,
  .ivu-table th {
    border-bottom: 0;
  }

  .ivu-table:before {
    background-color: #efefef !important;
  }

  .ivu-table:after {
    background-color: #efefef !important;
  }

  .ivu-table-wrapper {
    border-top: 1px solid #efefef;
    border-left: 1px solid #efefef;
  }
}
</style>
